import { Link } from "react-router-dom";
import { resolveUrl } from "@/lib/api";

const Frame = ({ children, to, href }) => {
  const cls = "block mt-6 lg:mt-8 rounded-2xl bg-[#D9D9D9] overflow-hidden relative aspect-[5/1] md:aspect-[1010/120] df-fade-up";
  if (to) return <Link to={to} className={cls} data-testid="featured-banner">{children}</Link>;
  if (href) return <a href={href} target="_blank" rel="noreferrer" className={cls} data-testid="featured-banner">{children}</a>;
  return <div className={cls} data-testid="featured-banner">{children}</div>;
};

export const FeaturedBanner = ({ featured }) => {
  if (!featured || featured.type === "placeholder") return <Frame />;
  if (featured.type === "image") {
    return (
      <Frame href={featured.link || undefined}>
        <img src={resolveUrl(featured.image_url)} alt="Featured" className="absolute inset-0 w-full h-full object-cover" />
      </Frame>
    );
  }
  const v = featured.video;
  return (
    <Frame to={featured.link}>
      {v?.thumbnail_url && <img src={resolveUrl(v.thumbnail_url)} alt={v.title} className="absolute inset-0 w-full h-full object-cover" />}
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/20 to-transparent" />
      <div className="absolute left-4 md:left-8 bottom-3 md:bottom-6 text-white">
        <p className="text-[11px] md:text-[12px] font-semibold uppercase tracking-wider opacity-80">Featured</p>
        <p className="text-[16px] md:text-[22px] font-bold leading-tight drop-shadow" data-testid="featured-title">{v?.title}</p>
      </div>
    </Frame>
  );
};
